import React, {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';

//material-ui core
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import Typography from '@material-ui/core/Typography';
import DialogBlok from './DialogBlok';
import TextField from '@material-ui/core/TextField/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Stepper from '@material-ui/core/Stepper/Stepper';
import Step from '@material-ui/core/Step/Step';
import StepLabel from '@material-ui/core/StepLabel/StepLabel';
import globalContext from '../../../../config/context';
import Autocomplete from '@material-ui/lab/Autocomplete/Autocomplete';

//material-ui Icons

//import others

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 400,
  },
  div: {
    marginBottom: 20,
  },
  button: {
    position: 'absolute',
  },
  input: {
    // display: 'none',
    marginLeft: 24,
    width: 400,
  },
  comboBox: {
    width: '100%',
    paddingBottom: 10,
    disabled: 'true',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const DialogKelurahan = (props) => {
  const classes = useStyles();
  const {useAppContext} = globalContext;
  const [{pencarian}, {setPencarian, setAlert, setLoading}] = useAppContext();

  const {
    kecamatan,
    setKecamatan,
    kecamatanOptions,
    handleKecamatan,
    itemKecamatan,
    shpKelurahan,
    shxKelurahan,
    dbfKelurahan,
    shpKelurahanHandler,
    shxKelurahanHandler,
    dbfKelurahanHandler,
    progressKelurahan,
    onUploadKelurahan,
  } = props;

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    // setActiveStep(0);
    onUploadKelurahan();
  };

  useEffect(() => {
    if (pencarian.kecamatan) {
      setKecamatan(pencarian.kecamatan);
    }
  }, [pencarian.kecamatan, setKecamatan]);

  const stepKecamatan = () => {
    return (
      <Autocomplete
        id="combo-box-kecamatan"
        className={classes.comboBox}
        options={itemKecamatan}
        getOptionLabel={(option) => (option ? option.kd_kecamatan + ' - ' + option.nm_kecamatan : '')}
        value={kecamatanOptions}
        onChange={handleKecamatan}
        renderInput={(params) => <TextField {...params} label="Kecamatan" variant="outlined" />}
      />
    );
  };

  const stepUpload = () => {
    return (
      <div>
        <div className={classes.div}>
          <label htmlFor="contained-button-shp" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload SHP
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-shp"
            name="shp"
            onChange={shpKelurahanHandler}
            type="file"
          />
        </div>

        <div className={classes.div}>
          <label htmlFor="contained-button-shx" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload SHX
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-shx"
            name="shx"
            onChange={shxKelurahanHandler}
            type="file"
          />
        </div>

        <div className={classes.div}>
          <label htmlFor="contained-button-dbf" className={classes.button}>
            <Button variant="contained" color="primary" component="span">
              Upload DBF
            </Button>
          </label>
          <input
            required
            // accept="*"
            className={classes.input}
            id="contained-button-dbf"
            name="dbf"
            onChange={dbfKelurahanHandler}
            type="file"
          />
        </div>
      </div>
    );
  };

  function getSteps() {
    return ['Kecamatan', 'Upload'];
  }

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return stepKecamatan();
      case 1:
        return stepUpload();
      default:
        return 'Unknown stepIndex';
    }
  }

  //loading persen------------------------------------------------------------------------------------------------------
  CircularProgressWithLabel.propTypes = {
    value: PropTypes.number.isRequired,
  };

  function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="static" {...props} />
        <Box top={0} left={0} bottom={0} right={0} position="absolute" display="flex" alignItems="center" justifyContent="center">
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <div className={classes.root}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <div style={{paddingBottom: 10}}>All steps completed</div>
            <div style={{display: 'flex'}}>
              <Button variant="contained" color="primary" onClick={handleReset} style={{marginRight: 15}}>
                Upload
              </Button>
              <CircularProgressWithLabel value={progressKelurahan} />
            </div>
          </div>
        ) : (
          <div>
            <div>{getStepContent(activeStep)}</div>
            <div>
              <Button disabled={activeStep === 0} onClick={handleBack} className={classes.backButton}>
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                disabled={
                  kecamatan === '' && activeStep === 0
                    ? true
                    : (shpKelurahan === null || shxKelurahan === null || dbfKelurahan === null) && activeStep === 1
                }>
                {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DialogKelurahan;
